/*
 * 作者: 吴松泽
 * 创建时间: 2022-04-28 13:32:32
 * 修改时间: 2022-04-28 15:45:44
 * 版本: [1.0]
 * 版权: 国泰新点软件股份有限公司
 * 描述: sm2加密精简，同时支持小程序环境
 */
import sm2 from 'miniprogram-sm-crypto/src/sm2';
import charset from '../charset';

function sm2Encrypt(data, publickey, cipherMode) {
    // 对数据进行base64编码
    let msgData = charset.base64.encode(data);
    let pubkeyHex = publickey;

    if (pubkeyHex.length > 64 * 2) {
        pubkeyHex = pubkeyHex.substr(pubkeyHex.length - 64 * 2);
    }
    let encryptData = sm2.doEncrypt(msgData, publickey, cipherMode);

    return '04' + encryptData;
}

export default {
    encrypt: sm2Encrypt
};